import type React from 'react';

import {
  AccordionDetails,
  type AccordionDetailsProps,
  type AccordionProps,
  type AccordionSummaryProps,
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';

import { useStyles } from 'components/accordion/dialogAccordion/styles';

interface TMXDialogAccordionProps {
  accordionProps?: AccordionProps;
  accordionSummaryProps?: AccordionSummaryProps;
  accordionDetailsProps?: AccordionDetailsProps;
  accordionContent?: React.ReactElement;
  accordionSummaryContent?: React.ReactElement;
  onClick?(): void;
}

const TMXDialogAccordion: React.FC<React.PropsWithChildren<TMXDialogAccordionProps>> = ({
  accordionProps,
  accordionSummaryProps,
  accordionDetailsProps,
  accordionContent,
  accordionSummaryContent,
}) => {
  const { classes } = useStyles();
  const combinedClassNames = accordionProps?.className
    ? `${classes.expansionPanel} ${accordionProps.className}`
    : classes.expansionPanel;
  const combinedClasses = accordionProps?.classes
    ? `${classes.expansionPanelExpanded} ${accordionProps.classes}`
    : classes.expansionPanelExpanded;
  const combinedAccordionSummaryClassNames = accordionSummaryProps?.className
    ? `${classes.accordionSummary} ${accordionSummaryProps.className}`
    : classes.accordionSummary;
  const summaryExpanded = accordionSummaryProps?.classes
    ? `${classes.accordionExpanded} ${accordionSummaryProps.classes}`
    : classes.accordionExpanded;
  const summaryRoot = accordionSummaryProps?.classes
    ? `${classes.accordionSummaryRoot} ${accordionSummaryProps.classes}`
    : classes.accordionSummaryRoot;
  const summaryContent = accordionSummaryProps?.classes
    ? `${classes.accordionSummaryContent} ${accordionSummaryProps.classes}`
    : classes.accordionSummaryContent;
  const detailsClassName = accordionDetailsProps?.className
    ? `${classes.accordionDetails} ${accordionDetailsProps.className}`
    : classes.accordionDetails;

  return (
    <Accordion {...accordionProps} classes={{ expanded: combinedClasses }} className={combinedClassNames}>
      <AccordionSummary
        {...accordionSummaryProps}
        classes={{
          expanded: summaryExpanded,
          root: summaryRoot,
          content: summaryContent,
        }}
        className={combinedAccordionSummaryClassNames}
      >
        {accordionSummaryContent}
      </AccordionSummary>
      <AccordionDetails {...accordionDetailsProps} className={detailsClassName}>
        {accordionContent}
      </AccordionDetails>
    </Accordion>
  );
};

export default TMXDialogAccordion;
